"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

function importScript(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prelude = data.prelude,
      callback = data.callback,
      id = data.id;

  if (id && document.getElementById(id)) {
    return;
  }

  prelude && prelude();
  var script = document.createElement('script');
  script.type = 'text/javascript';

  if (id) {
    script.id = id;
  }

  script.src = url;

  if (callback) {
    script.onload = callback;
  }

  document.head.appendChild(script);
}

importScript["default"] = importScript;
var _default = importScript;
exports["default"] = _default;
module.exports = exports["default"];